// Wire-format types and constants shared between the api Lambdas and the web frontend.
// If a field is removed/renamed, update both sides + ADRs as needed.
// ─── Random-ID config (ADR-0007) ──────────────────────────────────────────────
export const ID_LENGTH = 8;
export const RANDOM_ID_REGEX = /^[A-Za-z0-9]{8}$/;
// ─── Vanity-ID config (ADR-0008) ──────────────────────────────────────────────
export const VANITY_MIN_LENGTH = 3;
export const VANITY_MAX_LENGTH = 32;
/** Vanity slug: lowercase, [a-z0-9-], no leading/trailing dash, length 3..32. */
export const VANITY_ID_REGEX = /^[a-z0-9](?:[a-z0-9-]{1,30}[a-z0-9])?$/;
/** Reserved slugs — keep this list in lockstep with any top-level route or feature path. */
export const RESERVED_VANITY_WORDS = new Set([
    "api", "r", "admin", "www", "static", "assets", "upload", "uploads",
    "terms", "privacy", "about", "contact", "home", "index", "app", "auth",
    "login", "signup", "signin", "logout", "account", "profile", "dashboard",
    "settings", "support", "help", "404", "500", "error", "test", "dev",
    "prod", "staging", "favicon", "robots", "sitemap",
]);
/** Returns null if the slug is a valid vanity id; otherwise a short reason string. */
export function validateVanitySlug(input) {
    if (input.length < VANITY_MIN_LENGTH)
        return `must be at least ${VANITY_MIN_LENGTH} characters`;
    if (input.length > VANITY_MAX_LENGTH)
        return `must be at most ${VANITY_MAX_LENGTH} characters`;
    if (!VANITY_ID_REGEX.test(input))
        return `lowercase letters, digits and dashes only (no leading/trailing dash)`;
    if (RESERVED_VANITY_WORDS.has(input))
        return `that name is reserved`;
    return null;
}
/** Combined regex used at resolve-time to accept both random and vanity ids. */
export const RESOLVE_ID_REGEX = /^(?:[A-Za-z0-9]{8}|[a-z0-9](?:[a-z0-9-]{1,30}[a-z0-9])?)$/;
// Backwards-compat alias for older code paths that imported ID_REGEX.
export const ID_REGEX = RESOLVE_ID_REGEX;
// ─── File constraints ─────────────────────────────────────────────────────────
export const MAX_FILE_BYTES = 10 * 1024 * 1024; // 10 MiB
export const ACCEPTED_CONTENT_TYPE = "application/pdf";
export const PRESIGNED_PUT_TTL_SECONDS = 300; // 5 min
// ─── Email (uploader analytics, ADR-0012) ─────────────────────────────────────
export const EMAIL_MAX_LENGTH = 254;
// Pragmatic email regex — matches the common case, rejects obvious garbage.
// Full RFC 5322 is ~3 KB and pointless; SES will reject malformed addresses anyway.
export const EMAIL_REGEX = /^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/;
/** Returns null if the email looks valid; otherwise a short reason. */
export function validateEmail(input) {
    const e = input.trim();
    if (!e)
        return "email required";
    if (e.length > EMAIL_MAX_LENGTH)
        return `email too long (max ${EMAIL_MAX_LENGTH} chars)`;
    if (!EMAIL_REGEX.test(e))
        return "invalid email";
    return null;
}
export function normalizeEmail(input) {
    return input.trim().toLowerCase();
}
// ─── Mobile (iOS + Android v1) ────────────────────────────────────────────────
export * from "./mobile.js";
//# sourceMappingURL=index.js.map